import { render, staticRenderFns } from "./NavPillsSection.vue?vue&type=template&id=753dfd04&"
import script from "./NavPillsSection.vue?vue&type=script&lang=js&"
export * from "./NavPillsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports